module.exports = __webpack_public_path__ + "fonts/RecklessNeue-LightItalic.4414656d.ttf";